var AnnotationStyleStates;
(function (AnnotationStyleStates) {
    AnnotationStyleStates["Default"] = "";
    AnnotationStyleStates["Highlighted"] = "Highlighted";
    AnnotationStyleStates["Selected"] = "Selected";
    AnnotationStyleStates["Locked"] = "Locked";
})(AnnotationStyleStates || (AnnotationStyleStates = {}));
export default AnnotationStyleStates;
//# sourceMappingURL=AnnotationStyleStates.js.map